var eBranches = 
{
    Soccer: 1,
    Basketball: 2,
    Football: 3,
    Tennis: 6,
    Baseball: 7,
    IceHockey: 8,
    Specials: 9,
    Handball: 10,
    RugbyLeague: 11,
    Golf: 12,
    SnookerAndPool: 13,
    MotorRacing: 14,
    Darts: 15,
    Cycling: 16,
    Poker: 17,
    Speedway: 18,
    Volleyball: 19,
    Boxing: 20,
    Athletics: 21,
    Cricket_: 22,
    Hockey: 23,
    Floorball: 24,
    Futsal: 25,
    TableTennis: 26,
    Bowls: 27,
    WinterSports: 28,
    Hurling: 29,
    Sailing: 30,
    WaterPolo: 31,
    BeachVolleyball: 32,
    BeachSoccer: 33,
    Badminton: 34,
    RugbyUnion: 35,
    Trotting: 36,
    Curling: 37,
    OlympicGames: 38,
    Bandy: 39,
    BeachHandball: 40,
    AussieRules: 41,
    WinterOlympic: 42,
    MMA: 43,
    Shooting: 44,
    Swimming: 45,
    Gymnastics: 46,
    Rowing: 47,
    Triathlon: 48,
    Kayak: 49,
    Judo: 50,
    Wrestling: 51,
    Archery: 52,
    Diving: 53,
    Equestrian: 54,
    Fencing: 55,
    ModernPenthathlon: 56,
    Taekwondo: 57,
    Weightlifting: 58,
    Cricket: 59,
    Surfing: 60,
    HorseRacing: 61,
    VirtualSports: 62,
    Netball: 63,
    eSports: 64,
    Chess: 65,
    GreyHoundsRacing: 66,
    GaelicFootball: 67,
    GaelicHurling: 68,
    SoccerPromotions: 69,
    VirtualSports_: 70,
    Racketlon: 71,
    VirtualSports3Way: 73,
    VirtualSports2Way: 75,
    //This branch configures in cms separate from other branches
    Casino: 99,
    // This branch is for soccer aggregated events
    SoccerAggregates: 141
}

window.eBranches = eBranches;